import { BrowserRouter } from "react-router-dom";
import RouterApp from "./routes/routes.js";
import { GlobalAlertsProvider } from "./contexts/GlobalAlertsContext.js";
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';
import { keycloakProviderInitConfig } from "./keycloak.js";


export default function App() {
  return (
    <ReactKeycloakProvider authClient={keycloak} initOptions={keycloakProviderInitConfig} autoRefreshToken>
      <BrowserRouter>
        <GlobalAlertsProvider>
          <RouterApp />
        </GlobalAlertsProvider>
      </BrowserRouter>
    </ReactKeycloakProvider>
  );
}